import React from 'react';
import Modal from '../../../BaseModule/Components/Modal';
import { Size } from '../../../../Enums/Size.enum';
import SubscriptionPaymentMethodSelect from './SubscriptionPaymentMethodSelect';
import styles from './SubscriptionPaymentMethodSelectModal.module.scss';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	subscriptionId: string;
	subscriptionPeriodId: string;
	onPaymentMethodSelect: (paymentMethod: string) => void;
}

const SubscriptionPaymentMethodSelectModal: React.FC<Props> = ({
	isOpen,
	onClose,
	subscriptionId,
	subscriptionPeriodId,
	onPaymentMethodSelect,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.SM}>
			<Modal.Header
				title={'component.subscriptionPaymentFailed.selectPaymentMethod'}
			/>
			<Modal.Content>
				<div className={styles.wrapper}>
					<SubscriptionPaymentMethodSelect
						subscriptionId={subscriptionId}
						subscriptionPeriodId={subscriptionPeriodId}
						onPaymentMethodSelect={onPaymentMethodSelect}
					/>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default SubscriptionPaymentMethodSelectModal;
